<template>
  <a-config-provider :locale="zhCN">
    <div id="app">
      <router-view></router-view>
    </div>
  </a-config-provider>
</template>

<script>
import zhCN from 'ant-design-vue/es/locale/zh_CN'
export default {
  name: 'app',
  data() {
    return {
      zhCN,
    }
  },
  methods: {
  }
}
</script>

<style>
#app {
  width: 100%;
  height: 100%;
}
</style>
